/* eslint-disable no-nested-ternary */
import Typography from '@mui/material/Typography';
import * as Sentry from '@sentry/nextjs';
import { format } from 'date-fns';
import React from 'react';
import FailedQueryCard from '~/components/FailedQueryCard';
import LoadingContent from '~/components/LoadingContent';
import NoRegistrationsFound from '~/components/NoRegistrationsFound';
import DebugContext from '~/context/DebugContext';
import { useIndexPageQuery } from '~/generated/apollo';
import useLogger from '~/hooks/useLogger';
import ExamineeLayout from '~/layouts/ExamineeLayout';
import RegistrationCard from './RegistrationCard';
import { StyledContainer, StyledOuterContainer } from './styles';
export const Page: React.FC = (): React.ReactElement => {
  const debugContext = React.useContext(DebugContext);
  const {
    data,
    loading,
    error,
    refetch
  } = useIndexPageQuery({
    // TODO: When apollo client pulls from the cache for a previously-fetched
    // currentDate, the data is stale. Why is it not caching this properly?
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      currentDate: debugContext.state.todayDateSimulated || format(new Date(), 'yyyy-MM-dd')
    }
  });
  const myRegistrations = data?.myRegistrations || [];
  const logger = useLogger('Registrations');
  const refetchRegistrations = async (): Promise<void> => {
    try {
      await refetch();
    } catch (err) {
      Sentry.captureException(err);
      logger.log(err);
    }
  };
  return <ExamineeLayout centerElement={<Typography component="h1" variant="h6">
          My Online Tests
        </Typography>} data-sentry-element="ExamineeLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
      <StyledOuterContainer data-sentry-element="StyledOuterContainer" data-sentry-source-file="index.tsx">
        <StyledContainer maxWidth="md" data-sentry-element="StyledContainer" data-sentry-source-file="index.tsx">
          {loading ? <LoadingContent /> : error ? <FailedQueryCard description="Please retry or contact the room proctor to determine how to proceed" icon="general.registration" onClick={refetchRegistrations} title="There was an error retrieving the registrations" /> : myRegistrations.length === 0 ? <NoRegistrationsFound /> : myRegistrations.map((registration): React.ReactElement => <RegistrationCard key={registration.registration.id} registration={registration} />)}
        </StyledContainer>
      </StyledOuterContainer>
    </ExamineeLayout>;
};
export default Page;